<template>
    <div class="prompt">
        <PromptFormVue />
    </div>
</template>
<script>
import PromptFormVue from './Quick prompt/PromptForm.vue'
export default{
components:{
    PromptFormVue
}
}
</script>
<style scoped>
.prompt{
    overflow: auto;
    height: calc(100% - 128px);
    width: 100%;
  padding: 62px 38px 38px 38px;
}
</style>
